// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.networkUIDeploymentContainer {
  padding-left: 74px;
  padding-right: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  max-height: 100vh;
  padding-bottom: 40px;
  overflow-y: auto !important;
}

.networkUIDeploymentContainer h2.user-path {
  margin: 0;
  padding: 0;
  color: #4a88b1;
  font-size: 14px;
  font-weight: normal;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.user-path-title {
  font-weight: bold;
  color: #185177;
}

@media (max-width: 800px) {
  .networkUIDeploymentContainer {
    padding-right: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 500px) {
  .networkUIDeploymentContainer {
    padding-right: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BeaconNetworkUI/NetworkUIDeployment.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB;wEACsE;AACxE;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":[".networkUIDeploymentContainer {\n  padding-left: 74px;\n  padding-right: 16px;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  max-height: 100vh;\n  padding-bottom: 40px;\n  overflow-y: auto !important;\n}\n\n.networkUIDeploymentContainer h2.user-path {\n  margin: 0;\n  padding: 0;\n  color: #4a88b1;\n  font-size: 14px;\n  font-weight: normal;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n.user-path-title {\n  font-weight: bold;\n  color: #185177;\n}\n\n@media (max-width: 800px) {\n  .networkUIDeploymentContainer {\n    padding-right: 16px;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n@media (max-width: 500px) {\n  .networkUIDeploymentContainer {\n    padding-right: 16px;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
